import { useState } from "react";
import { Form, redirect, useActionData, useNavigation } from "react-router-dom";
import { createOrder } from "../../services/apiRestaurant";
import Button from "../../ui/Button";
import EmptyCart from "../cart/EmptyCart";
import { useDispatch, useSelector } from "react-redux";
import { clearCart, getCart, getTotalCartPrice } from "../cart/cartSlice";
import store from '../../store'
import { formatCurrency } from '../../utils/helpers';
import { fetchAddress } from '../user/userSlice';

// https://uibakery.io/regex-library/phone-number
const isValidPhone = (str) =>
    /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        str
    );

function CreateOrder() {
    const [withPriority, setWithPriority] = useState(false);
    const {
        username,
        status: addressStatus,
        position,
        address,
        error: errorAddress,
    } = useSelector((state) => state.user);

    const isLoadingAddress = addressStatus === 'loading';

    const navigation = useNavigation()
    const isSubmitting = navigation.state === 'submitting';

    const formErrors = useActionData();
    const dispatch = useDispatch();

    const cart = useSelector(getCart);
    const totalCartPrice = useSelector(getTotalCartPrice);
    const priorityPrice = withPriority ? totalCartPrice * 0.2 : 0;
    const totalPrice = totalCartPrice + priorityPrice;

    if (!cart.length) return <EmptyCart />


    return (
        <div className="px-4 py-6">
            <h2 className="text-xl font-semibold mb-8">Ready to order? Let's go!</h2>

            <Form method="POST">
                <div className="mb-5 flex gap-2 flex-col sm:flex-row sm:items-center">
                    <label className="sm:basis-40">First Name</label>
                    <input className="input grow" type="text" name="customer" defaultValue={username} required />
                </div>

                <div className="mb-5 flex gap-2 flex-col sm:flex-row sm:items-center">
                    <label className="sm:basis-40">Phone number</label>
                    <div className="grow">
                        <input className="input w-full" type="tel" name="phone" required />
                    </div>
                    {formErrors?.phone && (
                        <p className="text-xs mt-2 text-red-700 bg-red-100 p-2 rounded-md">{formErrors.phone}</p>
                    )}
                </div>

                <div className="relative mb-5 flex gap-2 flex-col sm:flex-row sm:items-center">
                    <label className="sm:basis-40">Address</label>
                    <div className="grow">
                        <input
                            className="input w-full"
                            type="text"
                            name="address"
                            disabled={isLoadingAddress}
                            defaultValue={address}
                            required />
                        {addressStatus === 'error' && (
                            <p className="mt-2 rounded-md bg-red-100 p-2 text-xs text-red-700">
                                {errorAddress}
                            </p>
                        )}
                    </div>
                    {!position.latitude && !position.longitude &&
                        (
                            <span className="absolute right-0 top-[27px] z-50 md:right-0 md:top-0">
                                <Button disabled={isLoadingAddress} type='small' onClick={(e) => {
                                    e.preventDefault()
                                    dispatch(fetchAddress())
                                }
                                }>Get Position</Button>
                            </span>
                        )
                    }
                </div>

                <div className="mb-12 flex gap-5 items-center">
                    <input
                        className="h-6 w-6 accent-yellow-400"
                        type="checkbox"
                        name="priority"
                        id="priority"
                        value={withPriority}
                        onChange={(e) => setWithPriority(e.target.checked)}
                    />
                    <label htmlFor="priority" className="font-medium">Want to give your order priority?</label>
                </div>

                <div className="">
                    <input type="hidden" name="cart" value={JSON.stringify(cart)} />
                    <input type="hidden"
                        name="position"
                        value={
                            position.latitude && position.longitude ? `${position.latitude},${position.longitude}` : ''
                        }
                    />


                    <Button
                        type='primary'
                        disabled={isSubmitting}
                    >
                        {isSubmitting || isLoadingAddress ? 'Placing order...' : `Order now for ${formatCurrency(totalPrice)}`}
                    </Button>
                </div>
            </Form>
        </div >
    );
}


export async function action({ request }) {
    const formData = await request.formData();
    const data = Object.fromEntries(formData);
    const order = {
        ...data,
        cart: JSON.parse(data.cart),
        priority: data.priority === 'true',
    };

    const errors = {};
    if (!isValidPhone(order.phone))
        errors.phone = "Please provide correct phone number."

    if (Object.keys(errors).length > 0) return errors;

    const newOrder = await createOrder(order);

    store.dispatch(clearCart())

    return redirect(`/order/${newOrder.id}`);
}

export default CreateOrder;